import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Card,
  CardContent,
  Stepper,
  Step,
  StepLabel,
  CircularProgress,
  TextField
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { investorApi } from "../../api/api";
import CloseIcon from "@mui/icons-material/Close";
import { AccountBalance, Numbers, Code, LocationOn } from "@mui/icons-material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import QRCode from "qrcode.react";
import { QRCodeCanvas } from "qrcode.react";
import { useSelector } from "react-redux";



const AdvancePayment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userId = useSelector((state) => state.user.userId);
  const { data } = location.state || {};
  const [step, setStep] = useState(1);
  const [paymentScreenshot, setPaymentScreenshot] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const property = Array.isArray(data) ? data[0] : data;
  const [enteredAmount, setEnteredAmount] = useState(5000);
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, [step]);

  if (!data || !userId) {
    return (
      <Typography sx={{ p: 3, textAlign: "center" }}>
        No payment data available. Please go back and select a property.
      </Typography>
    );
  }


  // const requiredAmount = parseFloat(property.AdvancePayment);
  

  const requiredAmount = parseFloat(enteredAmount);
  const totalPrice =
    parseFloat(property.SqFtPrice) * parseFloat(property.SizeInSqFt);
  const ApartmenttotalPrice =
    parseFloat(property.Price) * parseFloat(property.SizeInSqFt);

  const handlePaymentSubmit = async () => {

  if (!enteredAmount || enteredAmount < 5000) {
    alert("Minimum advance payment is ₹5000");
    return;
  }

  try {

    const orderResponse = await investorApi.createRazorpayOrder({
      amount: enteredAmount
    });

    const { order_id, amount, currency, key } = orderResponse.data;

    const payload = new FormData();

    payload.append("userId", userId);
    payload.append("amount", enteredAmount);

    const propertyType = Number(property.PropertyType || property.type);

    if (propertyType === 1) {
      payload.append("project_id", property.project_id);
      payload.append("property_id", property.plot_id);
      payload.append("PropertyType", 1);
      payload.append("property_value", totalPrice);
    }

    else if (propertyType === 3) {
      payload.append("apartment_id", property.Id);
      payload.append("PropertyType", 3);
      payload.append("property_value", ApartmenttotalPrice);
    }

    else if (propertyType === 4) {
      payload.append("property_id", property.Pid);
      payload.append("PropertyType", 4);
      payload.append("property_value", property.MarketPrice);
    }

    else if (propertyType === 2) {
      payload.append("property_id", property.id);
      payload.append("PropertyType", 2);
      payload.append("property_value", property.MarketPrice);
    }

    const options = {
      key,
      amount,
      currency,
      name: "JEMINS Builders & Developers Private Limited",
      order_id,

      handler: async function (razorResponse) {

        payload.append("razorpay_payment_id", razorResponse.razorpay_payment_id);
        payload.append("razorpay_order_id", razorResponse.razorpay_order_id);
        payload.append("razorpay_signature", razorResponse.razorpay_signature);

        const response = await investorApi.confirmAdvancePayment(payload);

        if (response?.status === 200) {
          alert("Advance Payment Successful!");
          navigate("/home");
        } else {
          alert("Payment verification failed.");
        }
      },

      prefill: {
        name: "User",
        email: "test@example.com",
        contact: "9999999999",
      },

      theme: { color: "#3399cc" }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();

  } catch (err) {
    console.error(err);
    alert("Payment start failed.");
  }
};






  // const handleRazorpayPayment = () => {
  //   const selectedPlanData = plans.find((p) => p.name === selectedPlan);
  //   const amount = (selectedPlanData?.prices.yearly || 0) * 100; // Razorpay amount in paise

  //   const options = {
  //     key: "rzp_test_nPkKhyncGwCs69",
  //     amount: amount,
  //     currency: "INR",
  //     name: "RealMart",
  //     description: `Payment for ${selectedPlan} Plan`,

  //     handler: async function (razorResponse) {
  //       console.log("Razorpay Response:", razorResponse);

  //       alert("Payment Successful!");

  //       // ---- CALL YOUR BACKEND API ----

  //       const data = {
  //         userId: userId,
  //         planId: selectedPlanData?.id,
  //         selectedPlan: selectedPlan,
  //         selectedPeriod: "yearly",
  //         amount: amount / 100, // Save in ₹ (NOT paise)
  //         paymentId: razorResponse.razorpay_payment_id,
  //       }
  //       try {
  //         console.log(data);
  //         debugger
  //         const apiResponse = await vendorApi.storeSubscription(data);
  //         console.log("Backend Response:", apiResponse.data);
  //         debugger
  //         alert("Subscription saved successfully!");

  //         navigate("/SubscriptionSuccess");
  //       } catch (error) {
  //         console.error("Error saving subscription:", error);
  //         alert("Payment success but failed to save subscription!");
  //       }
  //     },
  //     prefill: {
  //       name: "User",
  //       email: "test@example.com",
  //       contact: "9999999999",
  //     },
  //     theme: {
  //       color: "#3399cc",
  //     },
  //   };

  //   const rzp = new window.Razorpay(options);
  //   rzp.open();
  // };

  // const steps = ["Property Details", "Bank Transfer", "Upload Proof"];

  // const bankDetails = [
  //   { icon: <AccountBalance />, label: "Bank Name", value: "HDFC Bank" },
  //   { icon: <Numbers />, label: "Account Number", value: "50100234765981" },
  //   { icon: <Code />, label: "IFSC Code", value: "HDFC0000123" },
  //   { icon: <AccountBalance />, label: "Account Holder", value: "Prabhakaran P" },
  //   { icon: <AccountBalance />, label: "Account Type", value: "Current Account" },
  //   { icon: <LocationOn />, label: "Branch", value: "Madurai Main Branch" }
  // ];

  return (
    <Box sx={{
      minHeight: "100vh"
    }}>
      <Box
        sx={{
          maxWidth: 600,
          margin: "auto",
          p: 3,
          mt: 3,
          borderRadius: 2,
          backgroundColor: "#fff",
          boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
          position: "relative",
        }}
      >
        <IconButton
          onClick={() => navigate(-1)}
          sx={{ position: "absolute", top: 8, right: 8, color: "#666" }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h5" gutterBottom sx={{ textAlign: "center", mb: 3 }}>
          Advance Payment
        </Typography>

        {/* <Stepper activeStep={step - 1} sx={{ mb: 4 }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper> */}


        {/* {step === 1 && ( */}
        <Box>
          <Card
            sx={{
              mb: 3,
              borderRadius: 2,
              border: "1px solid #e0e0e0",
              backgroundColor: "#fafafa",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              '&:hover': {
                boxShadow: "0 4px 12px rgba(0,0,0,0.12)"
              }
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: "#1a237e",
                      fontSize: "1.25rem",
                      mb: 0.5
                    }}
                  >
                    {property.PropertyName}

                  </Typography>
                  {property.PropertyType === 3 && (
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        color: "#1a237e",
                        fontSize: "1.25rem",
                        mb: 0.5
                      }}
                    >
                      {property.ApartmentName}
                    </Typography>
                  )}
                  {
                    (property.type === 1 || property.PropertyType) &&

                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        color: "#1a237e",
                        fontSize: "1.25rem",
                        mb: 0.5
                      }}
                    >
                      {property.PlotName}
                    </Typography>
                  }
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#666",
                      fontWeight: 500,
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                  >
                    <LocationOnIcon fontSize="small" sx={{ color: "black" }} />
                    {property.Address}, {property.City}
                  </Typography>

                </Box>
                <Box
                  sx={{
                    backgroundColor: "#e8f5e8",
                    color: "#2e7d32",
                    px: 2,
                    py: 0.5,
                    borderRadius: 1,
                    fontSize: "0.75rem",
                    fontWeight: 700
                  }}
                >
                  {property.Status}
                </Box>
              </Box>

              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(2, 1fr)',
                  gap: 2,
                  mt: 3
                }}
              >
                <Box>
                  <Typography variant="caption" sx={{ color: "#666", fontWeight: 600 }}>
                    PROPERTY SIZE
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 600, color: "#333" }}>
                    {property.SizeInSqFt} SQFT
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" sx={{ color: "#666", fontWeight: 600 }}>
                    FACING
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 600, color: "#333" }}>
                    {property.Facing}
                  </Typography>
                </Box>
                {(property.type === 1 || property.type === "2") && (
                  <Box>
                    <Typography variant="caption" sx={{ color: "#666", fontWeight: 600 }}>
                      PRICE PER SQFT
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600, color: "#333" }}>
                      ₹{parseFloat(property.SqFtPrice).toLocaleString()}
                    </Typography>
                  </Box>
                )}
                {/* <Box>
                  <Typography variant="caption" sx={{ color: "#666", fontWeight: 600 }}>
                    PROPERTY TYPE
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 600, color: "#333" }}>
                    {property.type === 1 ? "Project" :
                      property.type === "2" ? "Property" :
                        property.PropertyType === "3" ? "Apartment Flat" :
                          property.PropertyType === "4" ? "Individual Villa" :
                            "Unknown Type"}
                  </Typography>
                </Box> */}
              </Box>
            </CardContent>
          </Card>

          <Card
            sx={{
              mb: 3,
              borderRadius: 2,
              border: "1px solid #e0e0e0",
              backgroundColor: "white"
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: "#1a237e",
                  mb: 3,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}
              >
                💰 FINANCIAL BREAKDOWN
              </Typography>
              <Box sx={{ space: 2 }}>
                {[

                  ...(property.PropertyType === "4"
                    ? [
                      {
                        label: "Total Property Value",
                        value: `₹${parseFloat(property.MarketPrice).toLocaleString()}`,
                        color: "#1a237e",
                      },
                    ]
                    : []),
                  ...(property.type == 1 || property.type == "2"
                    ? [
                      {
                        label: "Total Property Value",
                        value: `₹${parseFloat(totalPrice).toLocaleString()}`,
                        color: "#1a237e",
                      },
                    ]
                    : []),

                  ...(Number(property.PropertyType) === 3
                    ? [
                      {
                        label: "Price per SqFt",
                        value: `₹${property.Price}`,
                        color: "#1a237e",
                      },
                      {
                        label: "Total Property Value",
                        value: `₹${ApartmenttotalPrice.toLocaleString("en-IN")}`,
                        color: "#1a237e",
                      },

                    ]
                    : []),



                  ...(property.type === 1 || property.type === "2"
                    ? [
                      {
                        label: "Price per SqFt",
                        value: `₹${parseFloat(property.SqFtPrice).toLocaleString()}`,
                        color: "#666",
                      },
                    ]
                    : []),
                ].map((item, index) => (
                  <Box
                    key={item.label}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      py: 2,
                      borderBottom: index < 1 ? "1px solid" : "none",
                      borderColor: "#f0f0f0",
                    }}
                  >
                    <Typography variant="body1" sx={{ color: "#666", fontWeight: 500 }}>
                      {item.label}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 700,
                        color: item.color,
                        fontSize: "1.1rem",
                      }}
                    >
                      {item.value}
                    </Typography>
                  </Box>
                ))}
              </Box>


            </CardContent>
          </Card>

          <CardContent sx={{ p: 2.5 }}>
            <Typography variant="caption" sx={{ color: "#666", fontWeight: 600 }}>
              ADVANCE PAYMENT REQUIRED
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 800, color: "#1a237e" }}>
              ₹{parseFloat(requiredAmount).toLocaleString()}
            </Typography>
            <Typography variant="caption" sx={{ color: "#666", mt: 1, display: 'block' }}>
              This amount will be processed securely via Razorpay
            </Typography>
          </CardContent>
          <CardContent sx={{ p: 2.5 }}>
            <Typography variant="caption" sx={{ color: "#666", fontWeight: 600 }}>
              ENTER ADVANCE AMOUNT (Minimum ₹5000)
            </Typography>

            <TextField
              fullWidth
              type="number"
              value={enteredAmount}
              onChange={(e) => setEnteredAmount(e.target.value)}
              inputProps={{ min: 5000 }}
              sx={{ mt: 1 }}
            />

            {enteredAmount < 5000 && (
              <Typography variant="caption" sx={{ color: "red" }}>
                Minimum advance amount is ₹5000
              </Typography>
            )}
          </CardContent>

          <Button
            variant="contained"
            fullWidth
            disabled={enteredAmount < 5000}
            onClick={handlePaymentSubmit}
            sx={{
              py: 1.5,
              fontWeight: 700,
              fontSize: "1rem",
              backgroundColor: "#1a237e",
              borderRadius: 2,
              textTransform: "none",
              boxShadow: "0 2px 8px rgba(26, 35, 126, 0.3)",
              '&:hover': {
                backgroundColor: "#283593",
                boxShadow: "0 4px 12px rgba(26, 35, 126, 0.4)"
              }
            }}
          >
            CONFIRM PAY
          </Button>
        </Box>
        {/* )} */}

        {/* 
        {step === 2 && (
          <Box> */}
        {/* <Typography
              variant="h5"
              sx={{
                color: "#1a237e",
                fontWeight: 700,
                textAlign: "center",
                mb: 1,
                fontSize: "1.5rem",
                letterSpacing: "-0.5px",
                maxWidth: "100%"
              }}
            >
              BANK TRANSFER DETAILS
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "#666",
                textAlign: "center",
                mb: 4,
                fontWeight: 500,
                fontSize: "14px"
              }}
            >
              Transfer the advance amount using <strong>NEFT or QR Code (UPI)</strong> to the details below.
            </Typography> */}



        {/* <Card
              sx={{
                mb: 3,
                borderRadius: 2,
                border: "2px solid #1a237e",
                backgroundColor: "#f8f9ff",
                textAlign: "center"
              }}
            >
              <CardContent sx={{ p: 2.5 }}>
                <Typography variant="caption" sx={{ color: "#666", fontWeight: 600 }}>
                  PAYMENT AMOUNT
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 800, color: "#1a237e" }}>
                  ₹{parseFloat(requiredAmount).toLocaleString()}
                </Typography>
              </CardContent>
            </Card>

            <Card
              sx={{
                mb: 3,
                borderRadius: 2,
                border: "0px solid #e0e0e0",
                backgroundColor: "white",
                boxShadow: "0 2px 12px rgba(0,0,0,0.08)"
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    color: "#333",
                    mb: 3,
                    display: 'flex',
                    alignItems: 'start',
                    justifyContent: 'start',
                    gap: 1
                  }}
                >
                  🏦 BANK ACCOUNT DETAILS
                </Typography>

                <Box
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "16px",
                    padding: "0",
                    border: "1px solid #e8eaf6",
                    boxShadow: "0 4px 20px rgba(26, 35, 126, 0.08)",
                    mb: 3,
                    overflow: "hidden"
                  }}
                >
                 
                  <Box
                    sx={{
                     
                      color: "white",
                      padding: "20px 24px",
                      display: "flex",
                      alignItems: "center",
                      gap: 2
                    }}
                  >
                    <Box sx={{ fontSize: "1.4rem" }}>🏦</Box>
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: "700", fontSize: "1.1rem", color: "black" }}>
                        Bank Transfer Details
                      </Typography>
                      <Typography variant="body2" sx={{ opacity: 0.9, fontSize: "0.85rem", color: "black" }}>
                        Complete your payment using these bank details
                      </Typography>
                    </Box>
                  </Box>

                 
                  <Box sx={{ padding: "8px 0" }}>
                    {bankDetails.map((detail, index) => (
                      <Box
                        key={detail.label}
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "16px 24px",
                          borderBottom: index < bankDetails.length - 1 ? "1px solid #f5f5f5" : "none",
                          transition: "background-color 0.2s ease",
                          "&:hover": {
                            backgroundColor: "#f8f9ff"
                          },
                          width: "100%"
                        }}
                      >

                        <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: { xs: "100%", sm: "50%" } }}>
                          <Box sx={{ color: "#1a237e", fontSize: "1.2rem" }}>
                            {detail.icon}
                          </Box>
                          <Typography
                            variant="body1"
                            sx={{
                              color: "#666",
                              fontWeight: "600",
                              fontSize: "0.9rem"
                            }}
                          >
                            {detail.label}
                          </Typography>
                        </Box>


                        <Box
                          sx={{
                            flex: 1,
                            textAlign: { xs: "center", sm: "start" },
                            width: { xs: "100%", sm: "40%" },
                            marginTop: { xs: "10px", sm: "0px" },

                          }}>
                          <Typography
                            variant="body1"
                            sx={{
                              color: "#1a237e",
                              fontWeight: "700",
                              fontSize: "0.95rem",
                              wordBreak: "break-word"
                            }}
                          >
                            {detail.value}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </Box>

              
                <Card
                  sx={{
                    mb: 3,
                    borderRadius: 2,
                    border: "1px solid #e0e0e0",
                
                    boxShadow: "0 2px 12px rgba(0,0,0,0.08)"
                  }}
                >
                  <CardContent sx={{ p: 1, textAlign: "center" }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        color: "#333",
                        mb: 3,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      
                      }}
                    >
                      📱 ALTERNATIVE: UPI PAYMENT
                    </Typography>

                    <Box
                      sx={{
                        display: "inline-block",
                        p: 3,
                        borderRadius: 2,
                        backgroundColor: "#fff",
                        border: "1px solid #f0f0f0",
                        mb: 3,
                        position: "relative"
                      }}
                    >
                      <QRCodeCanvas
                        value={`upi://pay?pa=prabhakaranplkk@okhdfcbank&pn=${encodeURIComponent(
                          "Prabhakaran"
                        )}&am=${requiredAmount}&cu=INR`}
                        size={200}
                        includeMargin={true}
                      />


                      <Box
                        sx={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          backgroundColor: "#1a237e",
                          color: "white",
                          width: 24,
                          height: 24,
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                          fontWeight: "bold"
                        }}
                      >
                        ₹
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        backgroundColor: "#f8f9fa",
                        borderRadius: 2,
                        p: { xs: 2, sm: 2.5 },
                        border: "1px solid #e9ecef"
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: "#333",
                          mb: 2,
                          textAlign: "center",
                          fontSize: { xs: "0.9rem", sm: "1rem" }
                        }}
                      >
                        UPI PAYMENT INSTRUCTIONS
                      </Typography>

                   
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: { xs: 'column', sm: 'row' },
                          gap: { xs: 1.5, sm: 2 },
                          mb: 2,
                          alignItems: 'center',
                          justifyContent: 'space-between'
                        }}
                      >
                        <Box sx={{ textAlign: { xs: 'center', sm: 'left' }, flex: 1 }}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: "#666",
                              fontWeight: 600,
                              display: 'block',
                              fontSize: { xs: "0.75rem", sm: "0.75rem" }
                            }}
                          >
                            PAYMENT METHOD
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 600,
                              color: "#1a237e",
                              fontSize: { xs: "0.85rem", sm: "0.875rem" }
                            }}
                          >
                            UPI QR Code
                          </Typography>
                        </Box>

                        <Box sx={{ textAlign: { xs: 'center', sm: 'right' }, flex: 1 }}>
                          <Typography
                            variant="caption"
                            sx={{
                              color: "#666",
                              fontWeight: 600,
                              display: 'block',
                              fontSize: { xs: "0.75rem", sm: "0.75rem" }
                            }}
                          >
                            UPI ID
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 600,
                              color: "#1a237e",
                              fontSize: { xs: "0.8rem", sm: "0.875rem" },
                              wordBreak: "break-all"
                            }}
                          >
                            prabhakaranplkk@okhdfcbank
                          </Typography>
                        </Box>
                      </Box>

                      <Typography
                        variant="body2"
                        sx={{
                          color: "#666",
                          textAlign: "center",
                          fontWeight: 500,
                          backgroundColor: "#e8f5e8",
                          p: { xs: 1, sm: 1.5 },
                          borderRadius: 1,
                          border: "1px solid #c8e6c9",
                          fontSize: { xs: "0.8rem", sm: "0.875rem" }
                        }}
                      >
                        Supported Apps: <strong>GPay • PhonePe • Paytm • BHIM</strong>
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
          
                <Box
                  sx={{
                    backgroundColor: "#fff3cd",
                    borderRadius: 2,
                    p: 2.5,
                    border: "1px solid #ffeaa7",
                    mb: 3
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 700,
                      color: "#856404",
                      mb: 2,
                      textAlign: "center",
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 1
                    }}
                  >
                    ⚠️ IMPORTANT TRANSFER INSTRUCTIONS
                  </Typography>

                  <Box component="ul" sx={{ pl: 2, m: 0 }}>
                    {[
                      `Transfer exact amount: ₹${parseFloat(requiredAmount).toLocaleString()}`,
                      "Use NEFT transfer method for faster processing",
                      "Include your full name in transaction remarks",
                      "Keep transaction receipt/screenshot for verification",
                      "Transactions may take 1-2 hours to reflect in our account",
                      "Send payment confirmation to support@company.com"
                    ].map((instruction, index) => (
                      <Typography
                        key={index}
                        component="li"
                        variant="body2"
                        sx={{ color: "#856404", mb: 1.5, fontSize: "0.85rem", lineHeight: 1.4 }}
                      >
                        {instruction}
                      </Typography>
                    ))}
                  </Box>
                </Box>
              </CardContent>
            </Card> */}


        {/* <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                mb: 3,
                p: 2,
                backgroundColor: "#f8f9fa",
                borderRadius: 2,
                border: "1px solid #e9ecef"
              }}
            >
              <Box sx={{ color: "#2e7d32", fontSize: "1.2rem" }}>🔒</Box>
              <Typography variant="body2" sx={{ color: "#666", fontWeight: 500 }}>
                <strong>Secure Banking</strong> • Encrypted Transaction Processing
              </Typography>
            </Box> */}


        {/* <Box sx={{
              display: "flex",
              flexDirection: { xs: "column-reverse", sm: "row" },
              gap: { xs: 1, sm: 2 },
              mt: { xs: 3, sm: 2 }
            }}>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => setStep(1)}
                sx={{
                  py: { xs: 1.5, sm: 1.5 },
                  fontWeight: 600,
                  borderRadius: { xs: 3, sm: 2 },
                  border: "2px solid #e0e0e0",
                  color: "#666",
                  textTransform: "none",
                  fontSize: { xs: "1rem", sm: "1rem" },
                  minHeight: { xs: "52px", sm: "auto" },
                  order: { xs: 2, sm: 1 },
                  '&:hover': {
                    border: "2px solid #666",
                    backgroundColor: "#f5f5f5",
                    transform: { sm: "translateY(-1px)" }
                  },
                  transition: "all 0.2s ease"
                }}
              >
                ← Back to Details
              </Button>
              <Button
                variant="contained"
                fullWidth
                onClick={() => setStep(3)}
                sx={{
                  py: { xs: 1.5, sm: 1.5 },
                  fontWeight: 700,
                  fontSize: { xs: "1rem", sm: "1rem" },
                  backgroundColor: "#2e7d32",
                  borderRadius: { xs: 3, sm: 2 },
                  textTransform: "none",
                  boxShadow: "0 2px 8px rgba(46, 125, 50, 0.3)",
                  minHeight: { xs: "52px", sm: "auto" },
                  order: { xs: 1, sm: 2 },
                  '&:hover': {
                    backgroundColor: "#1b5e20",
                    boxShadow: "0 4px 12px rgba(46, 125, 50, 0.4)",
                    transform: { sm: "translateY(-1px)" }
                  },
                  transition: "all 0.2s ease"
                }}
              >
                I HAVE TRANSFERRED ✓
              </Button>
            </Box> */}
        {/* </Box>
        )} */}


        {/* {step === 3 && (
          <Box>
            <Typography
              variant="h5"
              sx={{
                color: "#1a237e",
                fontWeight: 700,
                textAlign: "center",
                mb: 1,
                fontSize: "1.5rem",
                letterSpacing: "-0.5px"
              }}
            >
              PAYMENT VERIFICATION
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "#666",
                textAlign: "center",
                mb: 4,
                fontWeight: 500
              }}
            >
              Transfer the Advance Payment using NEFT or QR Code (UPI) to the details below.
            </Typography> */}


        {/* <Card
              sx={{
                mb: 3,
                borderRadius: 2,
                border: "2px dashed #1a237e",
                backgroundColor: "#f8f9ff",
                textAlign: "center",
                transition: "all 0.3s ease",
                '&:hover': {
                  borderColor: "#283593",
                  backgroundColor: "#f0f2ff"
                }
              }}
            >
              <CardContent sx={{ p: 4 }}>
                <Box sx={{ fontSize: "3rem", mb: 2, color: "#1a237e" }}>📄</Box>

                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    color: "#1a237e",
                    mb: 1
                  }}
                >
                  UPLOAD TRANSFER CONFIRMATION
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    color: "#666",
                    mb: 3,
                    maxWidth: "400px",
                    margin: "0 auto"
                  }}
                >
                  Upload screenshot of your NEFT transfer confirmation from your bank
                </Typography>

                <label
                  htmlFor="payment-upload"
                  style={{ display: "inline-block" }}
                >
                  <Button
                    variant="contained"
                    component="span"
                    sx={{
                      py: 1.5,
                      px: 4,
                      fontWeight: 700,
                      fontSize: "1rem",
                      backgroundColor: "#1a237e",
                      borderRadius: 2,
                      textTransform: "none",
                      boxShadow: "0 2px 8px rgba(26, 35, 126, 0.3)",
                      '&:hover': {
                        backgroundColor: "#283593",
                        boxShadow: "0 4px 12px rgba(26, 35, 126, 0.4)"
                      }
                    }}
                  >
                    📎 SELECT SCREENSHOT
                  </Button>
                </label>

                <input
                  id="payment-upload"
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setPaymentScreenshot(file);
                      setPreviewUrl(URL.createObjectURL(file));
                    }
                  }}
                />

                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    color: "#666",
                    mt: 2,
                    fontWeight: 500
                  }}
                >
                  Supported formats: JPG, PNG, PDF • Max size: 5MB
                </Typography>
              </CardContent>
            </Card> */}


        {/* {previewUrl && (
              <Card
                sx={{
                  mb: 3,
                  borderRadius: 2,
                  border: "1px solid #e0e0e0",
                  backgroundColor: "white",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        color: "#333",
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                      }}
                    >
                      👁️ TRANSACTION PROOF PREVIEW
                    </Typography>

                    <Box
                      sx={{
                        backgroundColor: "#e8f5e8",
                        color: "#2e7d32",
                        px: 2,
                        py: 0.5,
                        borderRadius: 1,
                        fontSize: "0.75rem",
                        fontWeight: 700
                      }}
                    >
                      READY FOR SUBMISSION
                    </Box>
                  </Box>

                  <Box sx={{ textAlign: "center", p: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}>
                    <img
                      src={previewUrl}
                      alt="Bank Transfer Confirmation Preview"
                      style={{
                        width: "100%",
                        maxHeight: 400,
                        objectFit: "contain",
                        borderRadius: "8px",
                        border: "1px solid #e0e0e0"
                      }}
                    />
                  </Box>

                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2, pt: 2, borderTop: "1px solid #f0f0f0" }}>
                    <Typography variant="caption" sx={{ color: "#666", fontWeight: 600 }}>
                      FILE: {paymentScreenshot?.name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "#666", fontWeight: 600 }}>
                      SIZE: {(paymentScreenshot?.size / 1024 / 1024).toFixed(2)} MB
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            )} */}


        {/* <Card
              sx={{
                mb: 4,
                borderRadius: 2,
                border: "1px solid #e0e0e0",
                backgroundColor: "#fffbf0"
              }}
            >
              <CardContent sx={{ p: 2.5 }}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 700,
                    color: "#333",
                    mb: 1.5,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}
                >
                  ✅ VERIFICATION REQUIREMENTS
                </Typography>

                <Box component="ul" sx={{ pl: 2, m: 0 }}>
                  {[
                    "Clear screenshot of NEFT transfer confirmation",
                    "Visible transaction reference number",
                    "Payment amount matching advance payment (₹" + parseFloat(requiredAmount).toLocaleString() + ")",
                    "Bank name and account details visible",
                    "Transaction date and time visible",
                    "Sender name in transaction remarks"
                  ].map((requirement, index) => (
                    <Typography
                      key={index}
                      component="li"
                      variant="body2"
                      sx={{ color: "#666", mb: 1, fontWeight: 500 }}
                    >
                      {requirement}
                    </Typography>
                  ))}
                </Box>
              </CardContent>
            </Card> */}


        {/* <Box sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: { xs: 1, sm: 2 }
            }}>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => setStep(2)}
                sx={{
                  py: { xs: 1.5, sm: 1.5 },
                  fontWeight: 600,
                  borderRadius: { xs: 3, sm: 2 },
                  border: "2px solid #e0e0e0",
                  color: "#666",
                  textTransform: "none",
                  fontSize: { xs: "0.95rem", sm: "1rem" },
                  minHeight: { xs: "52px", sm: "auto" },
                  '&:hover': {
                    border: "2px solid #666",
                    backgroundColor: "#f5f5f5"
                  }
                }}
              >
                ← Back
              </Button>
              <Button
                variant="contained"
                fullWidth
                disabled={loading || !paymentScreenshot}
                onClick={handlePaymentSubmit}
                sx={{
                  py: { xs: 1.5, sm: 1.5 },
                  fontWeight: 700,
                  fontSize: { xs: "0.95rem", sm: "1rem" },
                  backgroundColor: paymentScreenshot ? "#2e7d32" : "#9e9e9e",
                  borderRadius: { xs: 3, sm: 2 },
                  textTransform: "none",
                  boxShadow: paymentScreenshot ? "0 2px 8px rgba(46, 125, 50, 0.3)" : "none",
                  minHeight: { xs: "52px", sm: "auto" },
                  '&:hover': paymentScreenshot ? {
                    backgroundColor: "#1b5e20",
                    boxShadow: "0 4px 12px rgba(46, 125, 50, 0.4)"
                  } : {},
                  '&.Mui-disabled': {
                    backgroundColor: "#e0e0e0",
                    color: "#9e9e9e"
                  }
                }}
              >
                {loading ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CircularProgress size={16} color="inherit" />
                    <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                      PROCESSING SUBMISSION...
                    </Box>
                    <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
                      PROCESSING...
                    </Box>
                  </Box>
                ) : (
                  <Box component="span">
                    <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                      SUBMIT FOR VERIFICATION
                    </Box>
                    <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
                      SUBMIT
                    </Box>
                    {paymentScreenshot ? ' ✓' : ''}
                  </Box>
                )}
              </Button>
            </Box> */}
        {/* </Box> */}
        {/* // )} */}
      </Box>
    </Box>
  );
};

export default AdvancePayment;